import Vue from "vue";

Vue.component("modifications-child", {
	props: ["child"],
	computed: {
		descriptionLabel: function() {
			return window.labels.description;
		},
		groupLabel: function() {
			return window.labels.group;
		},
		classLabel: function() {
			return window.labels.class;
		},
		subclassLabel: function() {
			return window.labels.subclass;
		},
		coverageExclusionTooltipLabel: function () {
			return window.labels.coverageExclusionTooltip;
		}
	},
	template: `
		<table :class="{ 'has-four-item-columns': child.hasFourItemColumns }">
			<colgroup>
				<col class="note-item-reference-number-column" />
				<col class="note-item-reference-number-column" />
				<col class="note-item-description-column" />
				<col class="note-item-group-column" v-if="child.hasFourItemColumns" />
				<col class="note-item-class-column" v-if="child.hasFourItemColumns" />
				<col class="note-item-subclass-column" v-if="child.hasFourItemColumns" />
				<col class="note-item-details-column" />
				<col class="note-item-reference-number-column" />
			</colgroup>
			<thead>
				<tr>
					<th>&nbsp;</th>
					<th>&nbsp;</th>
					<th>{{ descriptionLabel }}</th>
					<th v-if="child.hasFourItemColumns">{{ groupLabel }}</th>
					<th v-if="child.hasFourItemColumns">{{ classLabel }}</th>
					<th v-if="child.hasFourItemColumns">{{ subclassLabel }}</th>
					<th>{{ child.classificationSystem }}</th>
					<th>&nbsp;</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in child.items" :key="item.id" :id="'child-' + item.controlId">
					<td>
						<i v-if="item.excluded" class="fas fa-ban mt-2 has-text-danger" :title="coverageExclusionTooltipLabel"></i>
					</td>
					<td><div v-html="item.referenceNumber"></div></td>
					<td><div v-html="item.description"></div></td>					
					<td v-if="child.hasFourItemColumns">{{ item.groupText }}</td>
					<td v-if="child.hasFourItemColumns">{{ item.classText }}</td>
					<td v-if="child.hasFourItemColumns">{{ item.subclassText }}</td>
					<td><div v-html="item.detailsText"></div></td>
					<td>
						<i v-if="item.deleted" class="fas fa-trash"></i>
						<i v-if="item.added" class="fas fa-plus"></i>
					</td>
				</tr>
			</tbody>
		</table>
	`
});